import { mutate } from 'swr';
import { apiUserSettings } from '../../api';

const fetcher = async (payload) => {
    try {
        const data = await apiUserSettings(payload);
        return data;
    } catch (error) {
        throw new Error('Πρόβλημα επικοινωνίας με τον server');
    }
};

const UserSettingsReq = async ({ username, newusername, password, email, newPassword, resetexams, deleteac }) => {
    console.log('username:', username, 'newusername:', newusername, 'password:', password, 'email:', email, 'newPassword:', newPassword, 'resetexams:', resetexams, 'deleteac:', deleteac);

    try {
        const response = await mutate('user', fetcher({ username, newusername, password, newmail: email, newpassword: newPassword, resetexams, deleteac }), {
            rollbackOnError: true,
            revalidateOnFocus: false,
            revalidateOnReconnect: false,
            revalidateIfStale: true,
        });

        return (response ? response : null);
    } catch (error) {
        alert(error.message);
        return null;
    }
};

export default UserSettingsReq;
